import * as angular from 'angular';

import { ComponentsModule } from '~/core-app/components';
import { SharedServicesModule } from '../mode-shared-services';
import { DowngradedNotebooksUiModule } from '../downgraded-angular/notebooks/feature-notebooks.module';

import * as fromNotebookComponents from './notebook';
import * as fromNotebookCellComponents from './cell';
import { NotebookStateService } from './notebook/notebook-state-service';
import { AssetsModule } from '../assets.module';
import { downgradeInjectable } from '@angular/upgrade/static';
import { FeatureFlagsService } from 'libs/shared/util-feature-flags/src/lib/feature-flags.service';
import { NotebookSecretService } from '@mode/notebooks/domain';
import { NotebookHighlightService } from '../../plugins/ace/notebook-highlight.service';
import { CellExportFacade } from '@mode/notebooks/contract';

export const NotebookModule = angular
  .module('mode.notebook', [SharedServicesModule, AssetsModule, ComponentsModule, DowngradedNotebooksUiModule])
  .constant('ace', window['ace'])
  .service('NotebookStateService', NotebookStateService)
  .component('modeNotebookCellEditor', fromNotebookCellComponents.notebookCellEditorComponent)
  .component('modeNotebookCellGroup', fromNotebookCellComponents.notebookCellGroupComponent)
  .component('notebookSidebar', fromNotebookComponents.notebookSidebarComponent)
  .component('notebookToolbar', fromNotebookComponents.notebookToolbarComponent)
  .component('notebookView', fromNotebookComponents.notebookViewComponent)
  .component('modeNotebook', fromNotebookComponents.modeNotebookComponent)
  .directive('notebookHotkeys', [
    '$window',
    'RxStoreService',
    'NotebookDataService',
    'NgZone',
    fromNotebookComponents.notebookHotkeyDirective,
  ])
  .service('FeatureFlagsService', downgradeInjectable(FeatureFlagsService))
  .service('NotebookSecretService', downgradeInjectable(NotebookSecretService))
  .service('CellExportFacade', downgradeInjectable(CellExportFacade))
  .service('NotebookHighlightService', NotebookHighlightService)
  .directive('modeNotebookCellAce', fromNotebookCellComponents.modeNotebookAce).name;
